import React from 'react';
import { createInputsWrapper, EmailValidator, ErrorText, Images, useGlobalStyles } from 'utils';
import { MaskInput, ValidationInput } from 'components';
import { customerInformation } from '../../customerInfo/core';

export const CustomerCreditInfo = ({
                                     inputs,
                                     setInputs,
                                     error,
                                     setError,
                                     disables,
                                   }) => {
  const classes = customerInformation();
  const globalWrapper = useGlobalStyles();
  const globalScreens = createInputsWrapper();
  const lastCredit = inputs?.creditInfo?.[inputs?.creditInfo?.length - 1];

  const handleChange = (e, index) => {
    const params = { ...inputs };
    params.creditInfo[index][e.target.name] = e.target.value;
    setInputs(params);
    error === e.target.name && setError('');
  };

  const addNewRow = () => {
    if (lastCredit?.creditName || lastCredit?.score || lastCredit?.daysToPay) {
      const params = {
        ...inputs,
      };
      params.creditInfo.push({
        creditName: '',
        score: '',
        daysToPay: '',
      });
      setInputs(params);
    } else {
      setError(
        !lastCredit.creditName ? 'creditName' :
          !lastCredit.score ? 'score' :
            !lastCredit.daysToPay ? 'daysToPay' : '',
      );
    }
  };

  return (
    <div className={classes.infoWrapper} style={{ marginTop: 32 }}>

      <div className={classes.contactInfoTitleBox}>
        <p>Credit Information</p>
        <button
          disabled={disables}
          style={{opacity: disables ? 0.5 : 1}}
          onClick={addNewRow}
        >
          <img src={Images.addPlusBlue} alt="add" />
          <span>Add More</span>
        </button>
      </div>

      {inputs?.creditInfo?.map((item, index) => {
        return (
          <div key={index} className={globalScreens.basicInfoInputs}>
            <ValidationInput
              style={globalWrapper.simpleInput}
              variant={'outlined'}
              name={'creditName'}
              type={'text'}
              label={'Name'}
              typeError={error === 'creditName' && index === inputs?.creditInfo?.length - 1 ? ErrorText.field : ''}
              onChange={(e) => handleChange(e, index)}
              value={item?.creditName}
              disabled={disables}
            />
            <ValidationInput
              style={globalWrapper.simpleInput}
              variant={'outlined'}
              name={'score'}
              type={'number'}
              label={'Score'}
              typeError={error === 'score' && index === inputs?.creditInfo?.length - 1 ? ErrorText.field : ''}
              onChange={(e) => handleChange(e, index)}
              value={item.score}
              disabled={disables}
            />
            <ValidationInput
              style={globalWrapper.simpleInput}
              variant={'outlined'}
              name={'daysToPay'}
              type={'number'}
              label={'Days to Pay'}
              typeError={error === 'daysToPay' && index === inputs?.creditInfo?.length - 1 ? ErrorText.field : ''}
              onChange={(e) => handleChange(e, index)}
              value={item.daysToPay}
              disabled={disables}
            />
            <button
              className="reset-btn"
              style={{ opacity: (inputs?.creditInfo?.length === 1 || disables) ? 0.5 : 1, width: 50, height: 50 }}
              disabled={disables ? disables : inputs?.creditInfo?.length === 1}
              onClick={() => {
                const params = {
                  ...inputs,
                };
                params.creditInfo.splice(index, 1);
                setInputs(params);
              }}
            >
              <img src={Images.redTrash} alt="remove" />
            </button>
          </div>
        );
      })}
    </div>
  );
};